<script>
import { useStatusStyles } from '@/composables/useStatusStyles'
export default {
  name: 'ShootingStatus',
  props: {
    status: {
      type: String,
      required: true
    }
  },
  setup() {
    const { getCssClass, getStatusText } = useStatusStyles()
    return {
      getCssClass,
      getStatusText
    }
  },
  computed: {
    statusClass() {
      return this.getCssClass(this.status) + ' py-0 px-3 rounded-t-0'
    },
    statusText() {
      return this.getStatusText(this.status)
    }
  }
}
</script>

<template>
  <div>
    <v-card-text :class="statusClass" v-if="status">{{ statusText }}</v-card-text>
  </div>
</template>
